/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum SummaryNotificationsAliases {
  DECK_SUMMARY_NOTIFICATIONS = 'deck-summary-notifications',
  FETCH_SUMMARY_NOTIFICATIONS = 'fetch-summary-notifications',
  FIELD_TEXT = 'field-text',
  FIELD_TITLE = 'field-title',
  HPMS_DYNAMIC_DATE = 'hpms-dynamic-date',
  HPMS_SUMMARY_NOTIFICATIONS = 'hpms-summary-notifications',
  LAYOUT_0 = 'layout-0',
  LINK_SHOW_ALL = 'link-show-all',
  PANEL_1 = 'panel-1',
  PANEL_SHOW_ALL = 'panel-show-all',
  PANEL_SUMMARY_NOTIFICATIONS = 'panel-summary-notifications',
  TEXT_0 = 'text-0',
  TEXT_TEXT = 'text-text',
  TEXT_TITLE = 'text-title',
}
export { SummaryNotificationsAliases };
